export default __webpack_public_path__ + "static/media/time-indicator.537b0f3e.svg";